import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureNotifiLimAccountSummary(props) {
    return <AccountSummaryPage />
}